import React, { ReactElement, useState, useEffect } from 'react'
import { Table, Button, Modal, Form, Row, Col, Select } from 'antd'
import type { TablePaginationConfig } from 'antd/lib/table'
import NoSpaceInput from '@/components/noSpaceInput'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { getProjectList } from '@/services/table.service'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'

export default function SelectProject({ show, setShow, confirm, defaultValue, selection, }: {
    show: boolean
    setShow: any
    confirm: any
    defaultValue: string
    selection?: any[] | undefined
}): ReactElement {
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const [logLoading, setLogLoading] = useState(false)
    const [rowSelectKey, setRowSelectKey] = useState<(string | number)[]>([])
    const [selectedRows, setSelectedRows] = useState<any[]>([]) // Store selected row data
    const [paginationObj, setPaginationObj] = useState({
        pageIndex: 1,
        pageSize: 10,
        total: 0
    })
    const [formObj, setFormObj] = useState({
        projectCategory: '',
        projectName: '',
        projectBu: ''
    })
    const [projectList, setProjectList] = useState<any[]>([])
    const [winH, setWinH] = useState<number>(0)
    
    const closePop = () => {
        setShow(false)
    }
    const columns = [
        {
            title: t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('name'),
            dataIndex: 'projectName',
            key: 'projectName',
            // render(value: string) {
            //     return <p>{value}</p>
            // }
        },
        {
            title: t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('Classification'),
            dataIndex: 'projectCategory',
            key: 'projectCategory',
            width: '30%',
        },
        {
            title: t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('bu'),
            dataIndex: 'projectBu',
            key: 'projectBu',
            width: '30%',
        },
    ]

    const getRowSelection = () => {
        if (selection != undefined && selection.length > -1) {
            return {
                fixed: true,
                selectedRowKeys: rowSelectKey,
                onChange: (selectedRowKeys: (string | number)[], selectedRowsOnPage: any[]) => {
                    setRowSelectKey(selectedRowKeys)

                    setSelectedRows(prevRows => {
                        const newSelection = selectedRowsOnPage.filter(row =>
                            !prevRows.some(prev => prev.projectId === row.projectId)
                        )

                        const updatedRows = [...prevRows, ...newSelection]
                        const uniqueRows = Array.from(new Map(updatedRows.map(row => [row.projectId, row])).values())

                        return uniqueRows
                    })
                },
                onSelect: (record: any, selected: boolean) => {
                    setRowSelectKey(prevKeys =>
                        selected ? [...prevKeys, record.projectId] : prevKeys.filter(key => key !== record.projectId)
                    )
                    setSelectedRows(prevRows =>
                        selected ? [...prevRows, record] : prevRows.filter(row => row.projectId !== record.projectId)
                    )
                },
                onSelectAll: (selected: boolean, selectedRows: any[], changeRows: any[]) => {
                    if (selected) {
                        setRowSelectKey(prevKeys => [...new Set([...prevKeys, ...changeRows.map(row => row.projectId)])])
                        setSelectedRows(prevRows => [...new Set([...prevRows, ...changeRows])])
                    } else {
                        setRowSelectKey(prevKeys => prevKeys.filter(key => !changeRows.some(row => row.projectId === key)))
                        setSelectedRows(prevRows => prevRows.filter(row => !changeRows.some(r => r.projectId === row.projectId)))
                    }
                },
            }
        } else {
            return {
                fixed: true,
                onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                    console.log('onChange: ', selectedRowKeys, selectedRows)
                },
                onSelect: (record: any) => {
                    setRowSelectKey([record.projectId])
                }
            }
        }
    }

    const getOnRow = () => {
        return (record: any, index?: number) => {
            return {
                onClick() {
                    console.log('onRow click: ', record, index)
                    if (selection != undefined && selection.length > -1) {
                        setRowSelectKey(prevKeys =>
                            prevKeys.includes(record.projectId)
                                ? prevKeys.filter(key => key !== record.projectId)
                                : [...prevKeys, record.projectId]
                        )
                        setSelectedRows(prevRows =>
                            prevRows.some(row => row.projectId === record.projectId)
                                ? prevRows.filter(row => row.projectId !== record.projectId)
                                : [...prevRows, record]
                        )
                    } else {
                        setRowSelectKey([record.projectId])
                    }
                },
            }
        }
    }

    const getOnConfirm = () => {
        return () => {
            setShow(false)
            if (selection != undefined && selection.length > -1) {
                console.log(rowSelectKey, 'CONFIRMED')
                confirm(selectedRows)
                console.log(selectedRows, 'Selected')
            } else {
                const findObj = projectList.find(item => item.projectId === rowSelectKey[0])
                console.log(findObj, 'findObj')
                confirm(findObj)
            }
        }
    }

    const getProjectLs = async (params: any) => {
        try {
            setLogLoading(true)
            const res = await getProjectList(params).finally(() => {
                setLogLoading(false)
            })
            setProjectList(res?.content || [])
            setPaginationObj({
                pageIndex: params.pageNo,
                pageSize: params.pageSize,
                total: res?.totalElements
            })
            setFormObj({
                projectCategory: params.projectCategory,
                projectName: params.projectName,
                projectBu: params.projectBu
            })
        } catch (error: any) {
            setLogLoading(false)
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    const onChangePage = (pagination: TablePaginationConfig) => {
        getProjectLs({
            pageNo: pagination.current,
            pageSize: pagination.pageSize,
            projectCategory: formObj.projectCategory,
            projectName: formObj.projectName,
            projectBu: formObj.projectBu
        })
    }
    const onFinish = (values: any) => {
        getProjectLs({
            pageNo: 1,
            pageSize: paginationObj.pageSize,
            projectCategory: values.projectCategory,
            projectName: values.projectName,
            projectBu: values.projectBu
        })
    }

    useEffect(() => {
        getProjectLs({
            pageNo: 1,
            pageSize: 10,
            projectCategory: '',
            projectName: '',
            projectBu: ''
        })

        setWinH(document.body.clientHeight)
        window.onresize = () => {
            setWinH(document.body.clientHeight)
        }
        return () => {
            window.onresize = null
        }
    }, [])
    useEffect(() => {
        if (show && defaultValue && projectList.length > 0) {
            const findObj = projectList.find(item => item.almProjectId === defaultValue)
            console.log('findObj: ', findObj)
            if (findObj) {
                setRowSelectKey([findObj.projectId])
            }
        }
        if (show && selection && selection?.length > 0 && projectList.length > 0) {
            // const findObj = projectList.find(item => item.almProjectId === defaultValue)
            const findObj = projectList.filter(item => selection.includes(item.projectName))
            if (findObj.length > 0) {
                setRowSelectKey(prevKey => {
                    // Collect all projectIds from matchingProjects and add them to the prevKey if they don't already exist
                    const newProjectIds = findObj
                        .map(item => item.projectId)
                        .filter(projectId => !prevKey.includes(projectId)) // Only add new projectIds

                    return [...prevKey, ...newProjectIds] // Add the new projectIds to the previous state
                })
                setSelectedRows(prevKey => {
                    console.log('hiiiii')

                    // Extract the projectIds from prevKey (to check which ones are already selected)
                    const existingProjectIds = prevKey.map(row => row.projectId)

                    // Collect all projectIds from findObj, only adding new projectIds that aren't in prevKey
                    const newProjectIds = findObj.filter(item => !existingProjectIds.includes(item.projectId))

                    // Combine prevKey with new rows, ensuring uniqueness based on projectId
                    return [
                        ...prevKey,
                        ...newProjectIds.filter((newItem, index, self) =>
                            index === self.findIndex((item) => item.projectId === newItem.projectId)
                        ),
                    ]
                })

            }
        }
    }, [show, projectList])

    return (
        <Modal title={t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('project')} visible={show} 
            onOk={closePop}
            onCancel={closePop}
            width='90%'
            centered
            footer={[
                <Button key="submit" type="primary" onClick={getOnConfirm()}>{t('confirm')}</Button>,
                <Button key="close" onClick={closePop}>{t('close')}</Button>
            ]}
        >
            <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                onFinish={onFinish}
            >
                <Row>
                    <Col span={7}>
                        <Form.Item
                            label={t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('bu')}
                            name="projectBu"
                        >
                            <Select allowClear
                                style={{ width: '100%' }}
                                placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') 
                                 + t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('bu')}
                                options={[{ 'label':'ADS','value':'ADS' },
                                    { 'label':'BIC','value':'BIC' },
                                    { 'label':'CT','value':'CT' },
                                    { 'label':'ICI_1','value':'ICI_1' },
                                    { 'label':'ICI_2','value':'ICI_2' },
                                    { 'label':'ICI_3','value':'ICI_3' },
                                    { 'label':'IDC','value':'IDC' },
                                    { 'label':'IDS','value':'IDS' },
                                    { 'label':'IOV','value':'IOV' },
                                    { 'label':'ITT','value':'ITT' },
                                    { 'label':'ST','value':'ST' },
                                    { 'label':'IC_PMK','value':'IC_PMK' },
                                    { 'label':'ID_ST','value':'ID_ST' },
                                    { 'label':'ID_PMK','value':'ID_PMK' },
                                    { 'label':'HUD','value':'HUD' },
                                    { 'label':'PPI','value':'PPI' },
                                    { 'label':'CM_IMS','value':'CM_IMS' },
                                    { 'label':'EDS','value':'EDS' },
                                    { 'label':'OEs_SGP','value':'OEs_SGP' },
                                    { 'label':'NJ','value':'NJ' },
                                    { 'label':'SZ','value':'SZ' },
                                    { 'label':'SH_Raptor','value':'SH_Raptor' },
                                    { 'label':'CD KAWA','value':'CD KAWA' },
                                    { 'label':'IDA','value':'IDA' }
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Form.Item
                            label={t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('Classification')}
                            name="projectCategory"
                        >
                            <Select allowClear
                                style={{ width: '100%' }}
                                placeholder={t('Please Select') + (i18n.language !== 'zh' ? ' ' : '') 
                                 + t('project') + (i18n.language !== 'zh' ? ' ' : '') + t('Classification')}
                                options={[{ 'label':'Platform','value':'platform' },
                                    { 'label':'Technology','value':'technology' },
                                    { 'label':'Application','value':'application' },
                                    { 'label':'Chance','value':'chance' },
                                    { 'label':'Prestudy','value':'prestudy' },
                                    { 'label':'BU Support','value':'BU_support' },
                                    { 'label':'After-Sales Support','value':'after_sales_support' },
                                    { 'label':'Operation Management','value':'operation_management' },
                                    { 'label':'Subject','value':'subject' },
                                    { 'label':'Virtual Organization','value':'virtual_organization' }
                                ]}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={7}>
                        <Form.Item
                            label={t('projectName')}
                            name="projectName"
                        >
                            <NoSpaceInput allowClear
                                placeholder={t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') 
                                 + t('projectName')}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={3} style={{ textAlign: 'center' }}>
                        <Button type='primary' htmlType="submit">{t('search')}</Button>
                    </Col>
                </Row>
            </Form>
            <Table scroll={{ x: '100%', y: winH - 350 }}
                bordered
                dataSource={projectList}
                rowKey='projectId'
                columns={columns}
                loading={logLoading}
                pagination={{
                    current: paginationObj.pageIndex,
                    pageSize: paginationObj.pageSize,
                    total: paginationObj.total,
                }}
                onChange={onChangePage}
                rowSelection={{
                    ...getRowSelection(),
                    type: selection != undefined && selection.length > -1 ? 'checkbox' : 'radio',
                    selectedRowKeys: rowSelectKey,
                }}
                onRow={getOnRow()}
            />
        </Modal>
    )
}